/**
 * Generated DSL Slides
 * Auto-generated from knowledge base - Review and refine as needed
 */

import React from "react";
import { ArrowDown, CheckCircle2 } from "lucide-react";

export const dslSlides = [
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        We help Canadian Business Owners build a{" "}
        <strong className="font-bold text-orange-400">$10M WEALTH PLAN</strong>{" "}
        without{" "}
        <strong className="font-bold text-yellow-400">
          disrupting cash flow
        </strong>{" "}
        by leveraging a{" "}
        <strong className="font-bold text-orange-400">
          CRA-Compliant Strategy
        </strong>{" "}
        to{" "}
        <strong className="font-bold text-yellow-400">
          redirect tax dollars
        </strong>{" "}
        into building{" "}
        <strong className="font-bold text-orange-400">personal wealth</strong>.
      </p>
    ),
  },
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        <span className="text-orange-400 font-bold">Who is this for?</span>
      </p>
    ),
    body: (
      <div className="text-base md:text-xl lg:text-2xl text-white mt-4 md:mt-8 space-y-2 md:space-y-4 max-w-3xl mx-auto">
        <ul className="text-left space-y-2 md:space-y-3 mt-3 md:mt-6">
          <li className="flex items-start gap-2 md:gap-3">
            <span className="text-yellow-400 text-xl md:text-2xl">✓</span>
            <span>
              <strong className="text-orange-400">
                Canadian Business Owners
              </strong>{" "}
              or{" "}
              <strong className="text-orange-400">
                Incorporated Professionals
              </strong>
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-yellow-400 text-2xl">✓</span>
            <span>
              Earning <strong className="text-yellow-400">$500,000+</strong>{" "}
              annually in salary or dividends
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-yellow-400 text-2xl">✓</span>
            <span>
              Owning a business valued at{" "}
              <strong className="text-orange-400">$5M+</strong> (often
              Construction or Farming)
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-yellow-400 text-2xl">✓</span>
            <span>
              Ready to{" "}
              <strong className="text-orange-400">
                stop sending excess wealth to the CRA
              </strong>{" "}
              and start{" "}
              <strong className="text-orange-400">redirecting taxes</strong> to
              build your family legacy
            </span>
          </li>
        </ul>
      </div>
    ),
  },
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        You're probably wondering why we can{" "}
        <span className="text-orange-400">CONFIDENTLY</span> say this works...
      </p>
    ),
  },
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        Well...{" "}
        <span className="text-orange-400">
          here is exactly what we have done
        </span>{" "}
        for{" "}
        <span className="text-yellow-400">business owners just like you</span>
      </p>
    ),
    body: (
      <div className="text-base md:text-xl lg:text-2xl text-white mt-4 md:mt-8 max-w-3xl mx-auto space-y-3 md:space-y-6">
        <div className="bg-orange-500/20 border-l-4 border-orange-500 p-6 rounded-r-lg text-left">
          <p className="font-bold text-orange-300 mb-3 text-2xl">
            Dr. Combs' Success Story
          </p>
          <p className="text-slate-200 leading-relaxed">
            We helped a{" "}
            <strong className="text-white">cardiovascular specialist</strong>{" "}
            reduce his{" "}
            <strong className="text-orange-400">
              personal taxes by over 70%
            </strong>
            . This allowed him to transition{" "}
            <strong className="text-yellow-400">$500,000 per year</strong> from
            his corporation into his personal name—investing funds that were
            previously earmarked for taxes!
          </p>
        </div>
      </div>
    ),
  },
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        More <span className="text-orange-400">Success Stories</span> From Our{" "}
        <span className="text-yellow-400">Previous Clients</span>
      </p>
    ),
    body: (
      <div className="text-base md:text-xl lg:text-2xl text-white mt-4 md:mt-8 max-w-3xl mx-auto space-y-3 md:space-y-6">
        <div className="bg-orange-500/20 border-l-4 border-orange-500 p-6 rounded-r-lg text-left">
          <p className="font-bold text-orange-300 mb-3 text-2xl">
            The Miller Family Success Story
          </p>
          <p className="text-slate-200 leading-relaxed">
            We helped a <strong className="text-white">farm family</strong> with
            a{" "}
            <strong className="text-yellow-400">
              $35,000,000 enterprise value
            </strong>{" "}
            fully fund their partnership's{" "}
            <strong className="text-orange-400">buy/sell agreement</strong>. We
            did this without creating any undue stress on their day-to-day farm
            operations.
          </p>
        </div>
      </div>
    ),
  },
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        Another <span className="text-orange-400">Success Story</span> From Our{" "}
        <span className="text-yellow-400">Previous Clients</span>
      </p>
    ),
    body: (
      <div className="text-base md:text-xl lg:text-2xl text-white mt-4 md:mt-8 max-w-3xl mx-auto space-y-3 md:space-y-6">
        <div className="bg-orange-500/20 border-l-4 border-orange-500 p-6 rounded-r-lg text-left">
          <p className="font-bold text-orange-300 mb-3 text-2xl">
            Victor's Family Success Story
          </p>
          <p className="text-slate-200 leading-relaxed">
            We helped the owners of a{" "}
            <strong className="text-white">large enterprise </strong> gift{" "}
            <strong className="text-orange-400">$200,000 per year</strong> to
            their children, while simultaneously building a plan to{" "}
            <strong className="text-yellow-400">
              transition a $20,000,000 enterprise
            </strong>{" "}
            for their son to take over.
          </p>
        </div>
      </div>
    ),
  },
  {
    headline: (
      <p className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        So, if you want to see exactly how to{" "}
        <span className="text-orange-400">BUILD YOUR $10M WEALTH PLAN</span> and{" "}
        <span className="text-yellow-400">
          EXTRACT TRAPPED CORPORATE CAPITAL
        </span>{" "}
        tax-efficiently...
      </p>
    ),
    body: (
      <div className="text-white mt-8 max-w-4xl mx-auto space-y-6">
        <p className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold leading-relaxed text-center">
          <span className="text-yellow-400">
            Click the schedule call button
          </span>{" "}
          to see if you qualify and book a call
        </p>
        <div className="mt-8 flex flex-col items-center gap-4">
          <button
            onClick={() => {
              // Dispatch custom event that will be caught by the parent component
              const event = new CustomEvent("startAssessment");
              window.dispatchEvent(event);
            }}
            className="animate-bounce text-orange-400 hover:text-orange-300 transition-colors"
            aria-label="Scroll to assessment"
          >
            <ArrowDown className="w-12 h-12 md:w-16 md:h-16" />
          </button>
        </div>
      </div>
    ),
  },
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        If you are still here, you're probably wondering why your accountant has
        only talked about{" "}
        <span className="text-orange-400">
          <strong className="font-bold text-yellow-400">RRSPs</strong>
        </span>
        ,{" "}
        <span className="text-orange-400">
          <strong className="font-bold text-yellow-400">DIVIDENDS</strong>
        </span>
        , and the{" "}
        <span className="text-orange-400">
          <strong className="font-bold text-yellow-400">
            CAPITAL GAINS EXEMPTION
          </strong>
        </span>
        —and never mentioned the{" "}
        <span className="text-orange-400">advanced strategies</span> you're
        about to see.
      </p>
    ),
  },
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        The <span className="text-orange-400">Problem</span> With Traditional{" "}
        <span className="text-yellow-400">Wealth Building</span>
      </p>
    ),
    body: (
      <div className="text-base md:text-xl lg:text-2xl text-slate-200 mt-4 md:mt-8 max-w-3xl mx-auto space-y-2 md:space-y-4">
        <ul className="text-left space-y-4">
          <li className="flex items-start gap-3">
            <span className="text-orange-400 text-2xl font-bold">✗</span>
            <span>
              <strong className="text-white">High Taxes:</strong> You are likely
              paying <strong className="text-yellow-400">50%+</strong> on
              personal income, limiting your ability to build outside the corp.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-orange-400 text-2xl font-bold">✗</span>
            <span>
              <strong className="text-white">Trapped Cash:</strong> Money sits
              in your corporation because withdrawing it triggers{" "}
              <strong className="text-orange-400">massive tax bills</strong>.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-orange-400 text-2xl font-bold">✗</span>
            <span>
              <strong className="text-white">No Legacy Protection:</strong>{" "}
              Paying taxes doesn't build an estate. It just funds the government
              instead of{" "}
              <strong className="text-yellow-400">your family</strong>.
            </span>
          </li>
        </ul>
      </div>
    ),
  },
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        <span className="text-orange-400">What you should do instead...</span>
      </p>
    ),
    body: null,
  },
  {
    headline: null,
    body: (
      <div className="text-base md:text-xl lg:text-2xl text-white mt-4 md:mt-8 max-w-3xl mx-auto space-y-2 md:space-y-4">
        <ul className="text-left space-y-5">
          <li className="flex items-start gap-3">
            <CheckCircle2 className="w-7 h-7 text-yellow-400 flex-shrink-0 mt-1" />
            <span>
              Access your corporate cash personally at a{" "}
              <strong className="text-orange-400">tax rate below 20%</strong>{" "}
              instead of paying half to the CRA.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <CheckCircle2 className="w-7 h-7 text-yellow-400 flex-shrink-0 mt-1" />
            <span>
              Grow your wealth{" "}
              <strong className="text-yellow-400">tax-free</strong> inside your
              company, safe from market crashes.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <CheckCircle2 className="w-7 h-7 text-yellow-400 flex-shrink-0 mt-1" />
            <span>
              Ensure your family keeps{" "}
              <strong className="text-orange-400">100% of your estate</strong>{" "}
              instead of losing millions to taxes when you pass away.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <CheckCircle2 className="w-7 h-7 text-yellow-400 flex-shrink-0 mt-1" />
            <span>
              Keep your money{" "}
              <strong className="text-yellow-400">accessible</strong> for
              business deals today while it builds a legacy for tomorrow.
            </span>
          </li>
        </ul>
      </div>
    ),
  },
  {
    headline: (
      <p className="text-lg md:text-2xl lg:text-3xl xl:text-4xl text-white leading-relaxed max-w-4xl mx-auto font-semibold">
        We will show you <span className="text-orange-400">EXACTLY HOW</span> to
        do this in a 15-minute virtual meeting.{" "}
        <span className="text-yellow-400">Click the button below</span> to
        confirm you qualify and{" "}
        <span className="text-orange-400">speak to an advisor now</span>.
      </p>
    ),
    body: (
      <div className="text-white mt-8 max-w-4xl mx-auto space-y-6">
        <div className="mt-8 flex flex-col items-center gap-4">
          <button
            onClick={(e) => {
              e.preventDefault();
              try {
                // Dispatch custom event that will be caught by the parent component
                const event = new CustomEvent("startAssessment");
                window.dispatchEvent(event);
              } catch (error) {
                console.error(
                  "Error dispatching startAssessment event:",
                  error
                );
              }
            }}
            className="animate-bounce text-orange-400 hover:text-orange-300 transition-colors"
            aria-label="Scroll to assessment"
            type="button"
          >
            <ArrowDown className="w-12 h-12 md:w-16 md:h-16" />
          </button>
        </div>
      </div>
    ),
  },
];
